import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BfiDataGrid, Column } from '../../common/SharedComponents';
import { BorrowerApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { GridSettingType } from '@apply/constants';
import { onActionsCellRender, executeAction } from '../common/BorrowerFunctions';
import { ActionType } from '../common/constants/ActionType';
import { formatPhone } from '../../common/SharedFunctions';
import { useNavigate } from 'react-router-dom';

const PrincipalsTable = ({ gridStore }) => {
    const searchState = useSelector((state) => state.searchState);
    const navigate = useNavigate();

    const borrowerApi = new BorrowerApi.BorrowerApi(applicationInsights);

    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const dataFunction = (criteria) => {
        return borrowerApi.getPrincipalsRecycleBin(criteria);
    };

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('principalId', dataFunction, searchState?.searchText?.borrowerPerson);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onCellDblClick = (e) => {
        if (e.rowType !== 'data' || e.column.type === 'detailExpand' || e.column.type === 'actions') {
            return;
        }
        var model = {
            actionId: ActionType.EditPrincipal,
            principalId: e.data.principalId,
        };
        executeAction(model, navigate);
    };

    const onPhoneRender = (e) => {
        if (!e.value) {
            return null;
        }
        return formatPhone(e.value);
    };

    if (!gridStore) {
        return '';
    }

    return (
        <BfiDataGrid
            id={'borrowerEntitiesGrid'}
            gridType={GridSettingType.BorrowerPersons}
            dataStore={dataStore}
            applicationInsights={applicationInsights}
            onCellDblClick={onCellDblClick}
        >
            <Column
                dataField='name'
                caption='Principal Name'
            />
            <Column
                dataField='street1'
                caption='Street '
                width={300}
            />
            <Column
                dataField='city'
                caption='City'
                width={120}
            />
            <Column
                dataField='state'
                caption='State'
                width={70}
            />
            <Column
                dataField='email'
                caption='Email'
                width={200}
            />
            <Column
                dataField='phone'
                caption='Phone'
                width={110}
                cellRender={onPhoneRender}
            />
            <Column
                type='actions'
                alignment='center'
                cellRender={(e) => onActionsCellRender(e, 'PrincipalsGrid')}
                width={50}
                allowReordering={false}
                allowSorting={false}
                allowResizing={false}
                fixed={true}
                fixedPosition={'right'}
            />
        </BfiDataGrid>
    );
};

export default PrincipalsTable;
